/** Whole-unit quantities for customer-facing shipping paperwork and packing slips. */
export function parseSalesOrderQuantity(value: string | number | null | undefined): number {
  if (value == null) return 0;
  const parsed = typeof value === "number" ? value : Number(value);
  return Number.isFinite(parsed) ? Math.round(parsed) : 0;
}

export function formatSalesOrderQuantity(value: string | number | null | undefined): string {
  if (value == null) return "";
  return String(parseSalesOrderQuantity(value));
}
